var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Jost;src:url(" + escape(require("../fonts/Jost-500-Medium.ttf")) + ") format(\"truetype\");font-weight:100;font-style:normal}", ""]);

// exports
